import UI_NAMES from "./ui.names"

/**
 * UI_CONTENT contains all the constants to build text content for the DOM
 */

export default {
  HOME_MENU_ITEM: "Inicio",

  RESOURCE_VIEW_MENU_ITEM: {
    with: ({ resourceName, view }) => {
      const condition = UI_NAMES.RESOURCE_VIEW_MENU_ITEM.with({ resourceName, view })
      switch (condition) {
        case "recuperadores-list-menu-item":
          return "Recuperadores"
        case "coordinadores-list-menu-item":
          return "Coordinadores"
        case "pesadores-list-menu-item":
          return "Pesadores"
        case "etapas-list-menu-item":
          return "Etapas"
        case "pesajes-list-menu-item":
          return "Pesajes"
        case "exportar-pesaje-list-menu-item":
          return "Exportar Pesajes"
        case "operaciones-create-menu-item":
          return "Cargar Operaciones"
        case "materiales-create-menu-item":
          return "Pesar Materiales"
        case "administradores-edit-menu-item":
          return "Modificar Detalles"
        default:
          return "default"
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/layout/constants/ui.content.js